import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { updateSearchParameters } from '../../../store/actions/search'
import { SearchParameter } from '../../../utilities/models'

const ActivitySummaryBanner = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const results = useSelector(_ => _.search.results)
    const [clicked, setClicked] = useState(false)

    useEffect(() => {
        if (clicked &&
            results &&
            results.content &&
            results.content[0]
        ) {
            navigate(`/map/${results.content[0].id}?query=[{"name":"contentTypes","value":"regionalMaps"},{"name":"mapTypes","value":"9"}]`)
        }
    }, [results, clicked, navigate])

    const handleClick = () => {
        dispatch(updateSearchParameters([
            new SearchParameter('contentTypes', 'regionalMaps'),
            new SearchParameter('mapTypes', '9')
        ]))
        setClicked(true)
    }

    return (
        <img 
            src={`https://webfiles.canadiandiscovery.com/public/CDD/images/activity-summary-banner.jpg`}
            alt="Activity Summary Maps"
            onClick={handleClick} 
            style={{ marginBottom: '16px', width: '100%', cursor: 'pointer', border: '1px solid black' }}/>
    )
}

export default ActivitySummaryBanner